import { DsSynopticsGenericObjectInterface } from '../interfaces/ds-synoptics-generic-object.interface';

export class DsSynopticsGenericObject {
  /**
   * Id of the object.
   */
  public id: number;

  /**
   * Title of the object.
   */
  public title: string;

  /**
   * Creates an instance of DsSynopticsGenericObject.
   *
   * @param jsonData Initial data.
   */
  constructor(jsonData: DsSynopticsGenericObjectInterface) {
    if (!jsonData) {
      return;
    }
    this.id = jsonData.id || this.id;
    this.title = jsonData.title || this.title;
  }
}
